/**
 * RBAC role codes allowed in Sales owner / Lead assignee pickers.
 * Match is OR across a user's assigned roles (`user_roles`).
 *
 * Canonical codes are the job titles used in Settings → Roles.
 * Aliases cover live company codes that already mean sales (e.g. `sal-salesman`).
 * Company-cloned roles (`sal-salesman__ORDAN`) match on the base code in the users API.
 */
export const SALES_OWNER_ROLE_CODES = [
  'sales-executive',
  'sales-manager',
  'sales-director',
  'gm-sales',
  'sales-gm',
  'director-sales',
  'sales-rep',
  'sal-salesman',
  'pre-sales',
] as const;

export function salesOwnerUserListFilters(includeUserId?: string | null): {
  is_active: true;
  role_codes: string[];
  include_user_id?: string;
} {
  const filters: {
    is_active: true;
    role_codes: string[];
    include_user_id?: string;
  } = {
    is_active: true,
    role_codes: [...SALES_OWNER_ROLE_CODES],
  };
  const extra = includeUserId?.trim();
  if (extra) filters.include_user_id = extra;
  return filters;
}
